module.exports = __webpack_public_path__ + "img/C03TechWoadRaiderChampion_ua.7b239cb9.webp";